import { render, staticRenderFns } from "./Moderation.vue?vue&type=template&id=51c68dd5"
import script from "./Moderation.vue?vue&type=script&lang=js"
export * from "./Moderation.vue?vue&type=script&lang=js"
import style0 from "./Moderation.vue?vue&type=style&index=0&id=51c68dd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports